import { N0FlightStatusRequest } from '@models/requests/flight-status-request.model';
import { N0FlightStatusResult } from '@models/responses/flight-status.model';
import { createAction, props } from '@ngrx/store';

const enum FlightInfoActionTypes {
  getFlightStatuses = '[flight-info] GET_FLIGHT_STATUSES',
  getFlightStatusesSuccess = '[flight-info] GET_FLIGHT_STATUSES_SUCCESS',
}

export const flightInfoGetFlightStatuses = createAction(
  FlightInfoActionTypes.getFlightStatuses,
  props<{ request: N0FlightStatusRequest }>(),
);

export const flightInfoGetFlightStatusesSuccess = createAction(
  FlightInfoActionTypes.getFlightStatusesSuccess,
  props<{ results: N0FlightStatusResult[] }>(),
);
